// extracted by mini-css-extract-plugin
export default {"online":"Online_online__ZQQgz","label":"Online_label__59ypr","count":"Online_count__hI4E3","link":"Online_link__98cl+"};